import React from 'react';

const TravisLogo = props => (
  <svg viewBox="0 0 48 48" width={32} height={32} {...props}>
    <path d="M6 25s4.207 2 18 2 18-2 18-2v-4H6z" fill="#afb42b" />
    <path
      d="M40 25c1.688.625 2 2 2 2 0 4.188-1.313 5.68-2 6-.938.438-4 1-4 1l1-12h3zM8 25c-1.688.625-2 2-2 2 0 4.188 1.313 5.68 2 6 .938.438 4 1 4 1l-1-12H8z"
      fill="#ffcc80"
    />
    <path
      d="M39 28c0-9.39-6.715-17-15-17S9 18.61 9 28s6.715 17 15 17 15-7.61 15-17z"
      fill="#ffe0b2"
    />
    <path d="M28 39c0-1.656-1.79-3-4-3s-4 1.344-4 3 1.79 3 4 3 4-1.344 4-3z" fill="#ffb74d" />
    <path d="M40 22l-2 9-3 2-7-2-2-4h-4l-2 4-7 2-3-2-2-9s6.375-2 16-2 16 2 16 2z" fill="#bcaaa4" />
    <path
      d="M34 28.89c-.578-.292-1.215.079-2.367.102-.863.031-1.582.04-1.63-1.375-.046-1.414.5-2.586 1.36-2.617.86-.031 1.645 1.09 1.75 2.504.032.39-.011.672-.101.883.797-.098.98.468.988.504zm-15-1.167c.012 1.37-.715 1.289-1.59 1.297-.09.003-.172.003-.254.003-.097.004-.191.004-.285.004-.848-.004-1.39-.039-1.871.22.012-.032.223-.5.984-.692-.082-.188-.136-.446-.148-.801-.055-1.375.793-2.746 1.668-2.754.875-.008 1.484 1.102 1.496 2.477z"
      fill="#263238"
    />
    <path
      d="M18 26.5c0 .277-.223.5-.5.5a.498.498 0 0 1-.5-.5c0-.277.223-.5.5-.5s.5.223.5.5zm13.5-.5c-.277 0-.5.223-.5.5s.223.5.5.5.5-.223.5-.5-.223-.5-.5-.5z"
      fill="#fff"
    />
    <path
      d="M39.75 23.602C39.48 23.516 34.75 21 24 21S8.52 23.516 8.25 23.602l-.875.273 1.734 7.734 3.72 2.48 7.866-2.25L22.617 28h2.766l1.922 3.84 7.867 2.25 3.719-2.48 1.734-7.735zm-2.64 6.789l-2.282 1.52-6.133-1.75L26.617 26h-5.234l-2.078 4.16-6.133 1.75-2.281-1.52-1.157-5.124C11.781 24.742 15.125 23 24 23s12.219 1.742 14.266 2.266z"
      fill="#546e7a"
    />
    <path
      d="M8 19c0-8.836 7.164-16 16-16s16 7.164 16 16c0 0-8.164-2-17-2S8 19 8 19z"
      fill="#d4e157"
    />
    <path
      d="M43 17s-4.785-4-19-4-19 4-19 4c0 5.215 1 8 1 8s3.805-4 18-4 18 4 18 4 1-3.035 1-8z"
      fill="#d4e157"
    />
    <path
      d="M40 34l-3 5a2.36 2.36 0 0 1-1.324.965l-5.028 1.945c-.71.203-1.48.063-2.074-.387L24 39l-4.57 2.523a2.37 2.37 0 0 1-2.078.387l-5.028-1.945A2.36 2.36 0 0 1 11 39l-3-5 4 2h4l5.152-3.105A2.986 2.986 0 0 0 24 35a2.995 2.995 0 0 0 2.84-2.07L32 36h4zM26.758 21.055A68.492 68.492 0 0 0 24 21c-9.941 0-14.781 1.96-16.793 3.137C6.488 25.262 3.652 29.77 3 32c4.031-5.77 11.586-9.074 15.105-10.363-1.16.847-3.246 2.46-5.105 4.363 3.688-2.555 12.219-4.59 13.758-4.945zm1.394.074C27.23 22.176 25.527 23.69 22 26c5.96-.18 12.36-3.645 12.941-3.969-1.816-.402-4.054-.734-6.789-.902zM20 8v3h2v-1h1v5h-1v2h4v-2h-1v-5h1v1h2V8z"
      fill="#bf360c"
    />
    <path
      d="M39.531 15.254a16.764 16.764 0 0 0-.652-2.113c-1.352-.461-2.836-1.07-5.879-1.508v5.879c-1.836-.18-5.621-.512-9-.512-3.379 0-7.164.332-9 .516V11.66a43.447 43.447 0 0 0-5.887 1.512 16.088 16.088 0 0 0-.644 2.082c1.164-.434 2.66-.875 4.531-1.258V20c2.773-.586 6.371-1 11-1s8.227.414 11 1v-6.004c1.867.383 3.367.824 4.531 1.258z"
      fill="#afb42b"
    />
  </svg>
);

export default TravisLogo;



// WEBPACK FOOTER //
// ./src/javascripts/app/Webhooks/templates/logos/TravisCILogo.es6.js